import * as d3 from 'd3'

const redColor = d3.rgb('#F68D7C')
const blueColor = d3.rgb('#6BC8E8')
const purpleColor = d3.rgb('#583D8B')
const yellowColor = d3.rgb('#FDD45C')

export const color = d3.scaleOrdinal([redColor, blueColor, purpleColor, yellowColor])
